import styled, { css } from 'styled-components';

export const SimpleFormGroup = styled.div`
  margin: 0 0 15px;
  &:last-child {
    margin: 0;
  }
`;

export const SimpleForm = styled.form`
  font-size: 15px;
  line-height: 1.15;
  color: ${(props) => (props.theme.theme === 'dark' ? '#fff' : '#000')};

  label {
    display: block;
    cursor: pointer;
    font-weight: normal;
    margin-bottom: 10px;
    select {
      margin-left: 0.5rem;
    }
  }
  input {
    /* width: 100%; */
    padding: 11px 10px 9px;
    border-radius: 4px;
    border: solid 1px #bebebe;
    height: 40px;
    min-width: 200px;
    ${(props) =>
      props.theme.ui === 'v2' &&
      css`
        height: 34px;
        border-radius: 8px;
      `}
  }

  select {
    cursor: pointer;
    /* padding: 11px 22px 9px 10px; */
    /* background-color: #fff; */
    // -webkit-appearance: none;
    // -moz-appearance: none;
    /* width: 100%; */
    /* border-radius: 4px; */
    /* border: solid 1px #bebebe; */
    /* height: 40px; */
    min-width: 200px;
  }
  ${(props) =>
    (props.theme.theme === 'dark' || props.theme.ui === 'v2') &&
    css`
      color: var(--cp-text);
      input {
        color: var(--cp-text);
        border-color: var(--cp-border);
        background: var(--cp-surface) !important;
      }
    `}
`;
